<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <div class="row">
            <div class="col d-flex align-items-center">
                <div>
                    <h6 class="header-pretitle">Overview</h6>
                    <h1 class="header-title">Agencies</h1>
                </div>
            </div>

            <div class="col-auto d-flex align-items-center">
                <router-link v-if="$userIsAdmin" :to="{ name: 'agencies.create' }" class="btn btn-sm btn-outline-primary">
                    <font-awesome :icon="['far', 'plus']" class="mr-2"/> Add Agency
                </router-link>
              </div>
          </div><!-- /.row -->
        </div> <!-- / .header-body -->
      </div>
    </div><!-- / .header -->

  <div class="container-fluid container-boxed">

      <div class="card">
        <loading-spinner v-if="fetching"/>

        <no-results v-else-if="haveNoAgencies">
          No agencies found.
        </no-results>

        <ul class="list-data">
          <li class="data-heading">
            <div class="row">
              <div class="col">Name</div>
              <div class="col-auto">Status</div>
            </div>
          </li>

          <agencies-list-item v-for="agency in agencies" :agency="agency" :key="agency.id"/>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { agencyComputed, agencyMethods } from 'vx/helpers'
import AgenciesListItem from './AgenciesListItem'

export default {
  components: {
    AgenciesListItem
  },

  data () {
    return {
      fetching: false
    }
  },

  computed: {
    ...agencyComputed,

    haveNoAgencies () {
      return this.agencies.length === 0
    }
  },

  created () {
    this.getAgencies()
  },

  methods: {
    ...agencyMethods
  }
}
</script>
